import { ComponentType } from 'react';
import { attachComponentData, getComponentData } from '@backstage/core-plugin-api';

/**
 * Copies a plugin page's routable-extension data (plugin ownership, mount
 * point) onto a wrapper component. Needed whenever a plugin's page is
 * wrapped (e.g. by a permission gate) before being used as a Route element,
 * since the new frontend system's legacy route converter inspects the
 * Route's element directly and can't see through an untagged wrapper.
 */
export function copyRoutableExtensionData<P>(
  wrapper: ComponentType<P>,
  source: ComponentType<any>,
): ComponentType<P> {
  const sourceNode = { type: source } as any;
  const plugin = getComponentData(sourceNode, 'core.plugin');
  const mountPoint = getComponentData(sourceNode, 'core.mountPoint');
  if (plugin) {
    attachComponentData(wrapper, 'core.plugin', plugin);
  }
  if (mountPoint) {
    attachComponentData(wrapper, 'core.mountPoint', mountPoint);
  }
  return wrapper;
}
